import React from 'react';
import type { ExtendedFormDefinition } from '@features/forms';

import type { Patient } from '../../types/types';
import { FormReviewAdapter } from '../patient-communication/FormReviewAdapter';

interface ReviewFormsSlidePaneProps {
  open: boolean;
  onClose: () => void;
  patient?: Patient;
  patientId: string;
  selectedFormIds: string[];
  forms?: ExtendedFormDefinition[];
  onSuccess?: () => void;
}

export const ReviewFormsSlidePane: React.FC<ReviewFormsSlidePaneProps> = ({
  open,
  onClose,
  patient,
  patientId,
  selectedFormIds,
  forms,
  onSuccess,
}) => {
  return (
    <FormReviewAdapter
      open={open}
      onClose={onClose}
      patient={patient}
      patientId={patientId}
      selectedFormIds={selectedFormIds}
      forms={forms}
      onSuccess={onSuccess}
    />
  );
};

export default ReviewFormsSlidePane;